import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { HomePage } from '../pages/HomePage'
import { LiveFeedPage } from '../pages/LiveFeedPage'
import { SourcesPage } from '../pages/SourcesPage'
import { PagesPage } from '../pages/PagesPage'
import { GroupsPage } from '../pages/GroupsPage'
import { TopicsPage } from '../pages/TopicsPage'
import { PlaceholderPage } from '../pages/PlaceholderPage'
import { NetworkPage } from '../features/network/ui/NetworkPage'
import { IntelPage } from '../features/intel/ui/IntelPage'
import { SavedPostsPage } from '../features/bookmarks/ui/SavedPostsPage'
import { AnalyticsPage } from '../pages/AnalyticsPage'
import { LoginPage } from '../pages/LoginPage'
import { LandingPage } from '../pages/LandingPage'
import { LandingFeaturesPage } from '../pages/LandingFeaturesPage'
import { LandingPlatformPage } from '../pages/LandingPlatformPage'
import { LandingUseCasesPage } from '../pages/LandingUseCasesPage'
import { LandingPricingPage } from '../pages/LandingPricingPage'
import { PublicOnlyRoute } from './routing/PublicOnlyRoute'
import { RequireAuth } from './routing/RequireAuth'
import { LegacyTopicRedirect } from './routing/LegacyTopicRedirect'
import { ROUTES } from './routes'
import { SettingsPage } from '../features/settings/ui/SettingsPage'
import { TopicTrendPage } from '../features/topics-trend/ui/TopicTrendPage'
import { TopicComparePage } from '../features/topic-compare/ui/TopicComparePage'
import { TrendIndexPage } from '../features/trends/ui/TrendIndexPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.marketing.home} element={<LandingPage />} />
        <Route path={ROUTES.marketing.features} element={<LandingFeaturesPage />} />
        <Route path={ROUTES.marketing.platform} element={<LandingPlatformPage />} />
        <Route path={ROUTES.marketing.useCases} element={<LandingUseCasesPage />} />
        <Route path={ROUTES.marketing.pricing} element={<LandingPricingPage />} />

        <Route element={<PublicOnlyRoute />}>
          <Route path={ROUTES.auth.login} element={<LoginPage />} />
        </Route>

        <Route element={<RequireAuth />}>
          <Route path={ROUTES.app.root} element={<HomePage />} />
          <Route path={ROUTES.app.topicsList} element={<TopicsPage />} />
          <Route path="/app/topics/:topicId/feed" element={<LiveFeedPage />} />
          <Route path="/app/topics/:topicId/analytics" element={<AnalyticsPage />} />
          <Route path="/app/topics/:topicId/trends" element={<TopicTrendPage />} />
          <Route path="/app/topics/:topicId/network" element={<NetworkPage />} />
          <Route path="/app/topics/:topicId/reports" element={<IntelPage />} />
          <Route path="/app/topics/:topicId/saved" element={<SavedPostsPage />} />
          <Route path={ROUTES.app.sources} element={<SourcesPage />} />
          <Route path={ROUTES.app.pages} element={<PagesPage />} />
          <Route path={ROUTES.app.groups} element={<GroupsPage />} />
          <Route
            path={ROUTES.app.management}
            element={<PlaceholderPage title="Management" />}
          />
          <Route path={ROUTES.app.settings} element={<SettingsPage />} />
          <Route path={ROUTES.app.compare} element={<TopicComparePage />} />
          <Route path={ROUTES.app.trends} element={<TrendIndexPage />} />
          <Route
            path="/app/feed"
            element={
              <LegacyTopicRedirect
                build={ROUTES.app.topicFeed}
                fallback={ROUTES.app.topicsList}
              />
            }
          />
          <Route
            path="/app/analytics"
            element={
              <LegacyTopicRedirect
                build={ROUTES.app.topicAnalytics}
                fallback={ROUTES.app.topicsList}
              />
            }
          />
          <Route
            path="/app/topic"
            element={<Navigate to={ROUTES.app.topicsList} replace />}
          />
          <Route path="/app/*" element={<Navigate to={ROUTES.app.root} replace />} />
        </Route>

        <Route
          path="/public/topics/:slug/feed"
          element={<PlaceholderPage title="Public Feed" />}
        />
        <Route
          path="/public/topics/:slug/trends"
          element={<PlaceholderPage title="Public Trends" />}
        />
        <Route
          path="/public/topics/:slug/network"
          element={<PlaceholderPage title="Public Network" />}
        />
        <Route
          path="/public/topics/compare"
          element={<PlaceholderPage title="Public Compare" />}
        />

        <Route path="/feed" element={<Navigate to="/app/feed" replace />} />
        <Route path="/analytics" element={<Navigate to="/app/analytics" replace />} />
        <Route
          path="/management"
          element={<Navigate to={ROUTES.app.management} replace />}
        />
        <Route path="/settings" element={<Navigate to={ROUTES.app.settings} replace />} />
        <Route path="/sources" element={<Navigate to={ROUTES.app.sources} replace />} />
        <Route path="/pages" element={<Navigate to={ROUTES.app.pages} replace />} />
        <Route path="/groups" element={<Navigate to={ROUTES.app.groups} replace />} />
        <Route path="/topic" element={<Navigate to={ROUTES.app.topicsList} replace />} />

        <Route path="*" element={<Navigate to={ROUTES.marketing.home} replace />} />
      </Routes>
    </BrowserRouter>
  )
}
